document.addEventListener('DOMContentLoaded', () => {
  const checkboxes = document.querySelectorAll('input.js-userRoleChange');

  if (!checkboxes || checkboxes.length === 0) return;

  const checkboxTrainee = document.querySelector('input#checkbox_trainee');
  const checkboxAdviser = document.querySelector('input#checkbox_adviser');
  const checkboxMentor = document.querySelector('input#checkbox_mentor');

  if (!checkboxTrainee || !checkboxAdviser || !checkboxMentor) return;

  checkboxes.forEach(checkbox => {
    checkbox.addEventListener('change', (e) => {
      if (!e.target.checked) return;

      // 他のチェックボックスのチェックを外す
      switch (e.target.id) {
        case 'checkbox_trainee':
          checkboxAdviser.checked = false;
          checkboxMentor.checked = false;
          break;
        case 'checkbox_adviser':
          checkboxTrainee.checked = false;
          checkboxMentor.checked = false;
          break;
        case 'checkbox_mentor':
          checkboxTrainee.checked = false;
          checkboxAdviser.checked = false;
          break;
      }
    });
  });
});
